import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PosProductsModalComponent } from './pos-products-modal.component';
import { PosListModule } from '../pos-list/pos-list.module';
import { PosProductsModalService } from 'src/app/@core/services/pos-products-modal.service';



@NgModule({
  declarations: [PosProductsModalComponent],
  imports: [
    CommonModule,
    PosListModule,

  ],
  providers: [PosProductsModalService],
  exports: [PosProductsModalComponent]
})
export class PosProductsModalModule { }
